import { Route } from 'vue-router';
import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { GuardClass, GuardResolveFunction } from '../models';

import { APP_CONSTS } from '../store/app/app.consts';

export class SetFiltersVisibilityGuard extends GuardClass {

  public static async execute(to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    if (!!to.meta.filters && (to.name !== from.name)) {
      const store = CONTAINER.get<Store<any>>(TYPES.Store);
      await store.dispatch(`${ APP_CONSTS.moduleName }/${ APP_CONSTS.actions.setFiltersHidden }`, !!to.meta.filters().initiallyHidden);
    }
    next();
  }

}
